import React, { useState } from 'react';
import './TestimonialEditor.css';

interface TestimonialsEditorProps {
  selectedSection: string | null;
  editMode: boolean;
  editableContent: { [key: string]: string };
  handleSectionClick: (section: string) => void;
  handleEditChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  setEditableContent: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const TestimonialsEditor: React.FC<TestimonialsEditorProps> = ({
  selectedSection,
  editMode,
  editableContent,
  handleSectionClick,
  handleEditChange,
  handleSaveChanges,
  handleCancelEdit,
  iframeRef,
  setEditableContent,
}) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section);
  };

  const handleTestimonialImageChange = (event: React.ChangeEvent<HTMLInputElement>, testimonialId: string) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setEditableContent(prev => ({
          ...prev,
          [`${testimonialId}-image`]: reader.result as string,
        }));
        const iframeDocument = iframeRef.current?.contentDocument;
        if (iframeDocument) {
          const imgElement = iframeDocument.querySelector(`.card:nth-child(${testimonialId.split('-')[1]}) .testimonial-image`) as HTMLDivElement;
          if (imgElement) {
            imgElement.style.backgroundImage = `url(${reader.result as string})`;
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="testimonials-editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => toggleSection('testimonials')}>Testimonios</h3>
        {activeSection === 'testimonials' && (
          <div className="accordion-content">
            {['testimonial-1', 'testimonial-2', 'testimonial-3'].map((testimonialId, index) => (
              <div key={testimonialId} className="testimonial-item">
                <button
                  onClick={() => handleSectionClick(testimonialId)}
                  className={selectedSection === testimonialId ? 'selected-menu-item' : ''}
                >
                  Editar Testimonio {index + 1}
                </button>
                {editMode && selectedSection === testimonialId && (
                  <div className="editor-panel">
                    <h4>Editar {testimonialId}</h4>
                    <textarea
                      name={testimonialId}
                      value={editableContent[testimonialId] || ''}
                      onChange={handleEditChange}
                      placeholder="Texto del testimonio"
                    />
                    <input
                      type="file"
                      name={`${testimonialId}-image`}
                      onChange={(event) => handleTestimonialImageChange(event, testimonialId)}
                    />
                    <button onClick={handleSaveChanges}>Guardar Cambios</button>
                    <button onClick={handleCancelEdit}>Cancelar</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestimonialsEditor;
